module.exports = __webpack_public_path__ + "media/images/services/filtering-62158d0f0504d244357adc66183bf2df.jpg";